import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiImage } from 'react-icons/fi';
import { SCREENSHOT_PREFIX } from '../markdown/resolveImage';

export const ScreenshotPlaceholder: React.FC<{
  caption: string;
  screenshotKey: string;
}> = ({ caption, screenshotKey }) => {
  const { t } = useTranslation('HelpGuide');
  return (
    <figure className="my-5">
      <div className="flex aspect-video w-full flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed border-gray-300 bg-gray-50 text-gray-400 dark:border-gray-600 dark:bg-gray-800/60 dark:text-gray-500">
        <FiImage size={28} aria-hidden="true" />
        <span className="text-xs font-medium">
          {t('screenshot.placeholder')}
        </span>
        <code className="rounded bg-gray-100 px-1.5 py-0.5 text-[11px] text-gray-500 dark:bg-gray-700 dark:text-gray-400">
          {SCREENSHOT_PREFIX}
          {screenshotKey}
        </code>
      </div>
      {caption && (
        <figcaption className="mt-2 text-center text-xs text-gray-500 dark:text-gray-400">
          {caption}
        </figcaption>
      )}
    </figure>
  );
};
